import React, { useEffect, useState } from 'react';

export function LoadingBlock({ label = 'Carregando...' }) {
  const [progress, setProgress] = useState(0);
  const frames = [1, 2, 3, 4, 5, 6];
  const activeFrame = Math.min(
    frames.length - 1,
    Math.floor((progress / 100) * frames.length)
  );

  useEffect(() => {
    let frameId;
    const startedAt = performance.now();
    const duration = 12000;
    const holdDuration = 1400;

    const tick = (now) => {
      const elapsed = (now - startedAt) % (duration + holdDuration);
      const nextProgress = Math.min(100, Math.round((elapsed / duration) * 100));
      setProgress(nextProgress);
      frameId = requestAnimationFrame(tick);
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, []);

  return (
    <div className="loading-block perifa-loading-block" role="status" aria-label={label}>
      <div className="perifa-loading-video" aria-hidden="true">
        {frames.map((frame, index) => (
          <img
            key={frame}
            className={`perifa-loading-frame ${index === activeFrame ? 'is-active' : ''}`}
            src={`/loader/frame-${String(frame).padStart(2, '0')}.jpg`}
            alt=""
          />
        ))}
        <span className="perifa-loading-scanline" />
        <span className="perifa-loading-glow" />
      </div>
      <div className="perifa-loading-hud">
        <strong>CARREGANDO</strong>
        <div className="perifa-loading-progress-row">
          <div className="perifa-loading-progress">
            <span style={{ width: `${progress}%` }} />
          </div>
          <span className="perifa-loading-percent">{progress}%</span>
        </div>
      </div>
    </div>
  );
}
